<template>
  <div class="files-breadcrumbs"
    :style="containerWidth"
  >
    <div class="files-breadcrumbs__item files-breadcrumbs__item--first">
      <a class="no-decoration grey--text text--darken-1"
         @click.prevent="$router.push({
         path: '/pliki/',
         query: queryData,
         })">Pliki
      </a>
      <v-icon color="grey" class="files-breadcrumbs__icon mr-1">chevron_right</v-icon>
    </div>
    <BreadCrumbItem
      v-for="(breadcrumb, i) in breadcrumbs"
      :key="i"
      :breadcrumb="breadcrumb"
      :length="breadcrumbs.length"
      :index="i"
      :isBigger="isBigger"
      :recalculate="recalucalteWidth"
      :itemMinWidth="itemMinWidth"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadCrumbItem from './BreadcrumbsItem.vue';

export default {
  name: 'BreadcrumbsList',
  data: () => ({
    isBigger: false,
    maxItemsWidth: null,
    itemMinWidth: null,
    maxWidth: null,
    containerWidth: 'width: none',
  }),
  components: {
    BreadCrumbItem,
  },
  computed: {
    ...mapGetters('files', [
      'breadcrumbs',
    ]),
    queryData() {
      const { query } = this.$route;
      return {
        ...query,
      };
    },
  },
  methods: {
    getWidth() {
      const title = document.getElementsByClassName('files-toolbar-title');
      if (title.length > 0) {
        this.maxWidth = title[0].clientWidth;
      }
    },
    clearMinWidth() {
      const breadCrumbList = document.getElementsByClassName('files-breadcrumbs__item');
      if (breadCrumbList.length > 0) {
        Array.from(breadCrumbList).forEach((item) => {
          if (!item.classList.contains('files-breadcrumbs__item--first')) {
            item.style.minWidth = null;
          }
        });
      }
    },
    getBreadCrumbsWidth() {
      this.isBigger = false;
      this.containerWidth = 'width: auto';
      this.clearMinWidth();
      const breadCrumbList = document.getElementsByClassName('files-breadcrumbs');
      const firstItem = document.getElementsByClassName('files-breadcrumbs__item--first');
      if (breadCrumbList.length > 0) {
        this.maxItemsWidth = this.maxWidth - firstItem[0].clientWidth;
        const breadCrumbWidth = breadCrumbList[0].clientWidth;
        if (this.maxWidth <= breadCrumbWidth) {
          this.isBigger = true;
          this.containerWidth = 'width: 100%';
        }
      }
      if (firstItem.length > 0) {
        this.itemMinWidth = Math.floor(this.maxItemsWidth / this.breadcrumbs.length);
      }
    },
    recalucalteWidth() {
      this.getWidth();
      this.getBreadCrumbsWidth();
    },
  },
};
</script>
